import { useMutation } from '@apollo/client'
import { CreatePositionDocument } from 'generated/resources/graphql'

// TODO: resource registry should expose this as a input type
interface CreatePositionInput {
  companyId: number
  atsJobPostingId: number
  jobCatalogLevelId?: number
  managerId: number
}

export const useCreatePosition = () => {
  const [createPosition, { loading }] = useMutation(CreatePositionDocument)

  return {
    loading,
    create(variables: CreatePositionInput) {
      return createPosition({
        variables,
      })
    },
  }
}
